import { module_names } from './ModulesNameInDB';

export interface CustomRouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  extralink: boolean;
  submenu: CustomRouteInfo[];
  module_name: string;
}

export const CUSTOM_ROUTES: CustomRouteInfo[] = [
  {
    path: '',
    title: 'Dashboard',
    icon: 'mdi mdi-view-dashboard',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/daai/dashboard',
        title: 'Dashboard',
        icon: 'mdi mdi-view-dashboard',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.dashboard_module,
      },
    ],
    module_name: module_names.dashboard_module,
  },
  {
    path: '',
    title: 'CRM',
    icon: 'mdi mdi-chemical-weapon',
    class: 'has-arrow',
    extralink: false,
    submenu: [
      {
        path: '/daai/leads',
        title: 'Leads',
        icon: 'mdi mdi-contacts',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.lead_module,
      },
      {
        path: '/daai/prospect',
        title: 'Prospect',
        icon: 'mdi mdi-lan',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.prospect_module,
      },
      {
        path: '/daai/opportunity',
        title: 'Opportunity',
        icon: 'mdi mdi-lightbulb-on',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.opportunity_module,
      },
      {
        path: '/daai/followups',
        title: 'Followups',
        icon: 'mdi mdi-timeline-clock',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.followups_module,
      },
    ],
    module_name: module_names.static_module,
  },
  {
    path: '',
    title: 'Billing',
    icon: 'mdi mdi-library-plus',
    class: 'has-arrow',
    extralink: false,
    submenu: [
      {
        path: '/daai/clients',
        title: 'Clients',
        icon: 'mdi mdi-account-multiple-plus',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.clients_module,
      },
      {
        path: '/daai/projects',
        title: 'Projects',
        icon: 'mdi mdi-pandora',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.projects_module,
      },
      {
        path: '/daai/packages',
        title: 'Packages',
        icon: 'mdi mdi-package',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.package_module,
      },
      {
        path: '/daai/billables',
        title: 'Billable AddOns',
        icon: 'mdi mdi-plus-box',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.billableaddons_module,
      },
      {
        path: '/daai/proforma-invoice',
        title: 'Proforma Invoice',
        icon: 'mdi mdi-invoice',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.proformainvoice_module,
      },
      {
        path: '/daai/invoice',
        title: 'Invoice',
        icon: 'mdi mdi-invoice-check',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.invoice_module,
      },
      {
        path: '/daai/payment',
        title: 'Receipt',
        icon: 'mdi mdi-cash',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.payments_module,
      },
      {
        path: '/daai/creditnote',
        title: 'Credit Note',
        icon: 'mdi mdi-note-text',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.creditnote_module,
      },
    ],
    module_name: module_names.static_module,
  },
  {
    path: '',
    title: 'HRM',
    icon: 'mdi mdi-human-child',
    class: 'has-arrow',
    extralink: false,
    submenu: [
      {
        path: '/daai/hiring',
        title: 'Hiring',
        icon: 'mdi mdi-laptop',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.hiring_module,
      },
      {
        path: '/daai/employee',
        title: 'Employee',
        icon: 'mdi mdi-account-box-outline',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.employee_module,
      },
      {
        path: '/daai/leaves',
        title: 'Leaves',
        icon: 'mdi mdi-calendar-clock',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.leaves_module,
      },
      {
        path: '/daai/allowance',
        title: 'Allowance',
        icon: 'mdi mdi-note-text',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.allowance_module,
      },
      {
        path: '/daai/salary',
        title: 'Salary',
        icon: 'mdi mdi-cash-100',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.salary_module,
      },
      {
        path: '/daai/assets',
        title: 'Assets',
        icon: 'mdi mdi-developer-board',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.assets_module,
      },
    ],
    module_name: module_names.static_module,
  },
  {
    path: '',
    title: 'Finance',
    icon: 'mdi mdi-minus-box',
    class: 'has-arrow',
    extralink: false,
    submenu: [
      {
        path: '/daai/expenses',
        title: 'Expenses',
        icon: 'mdi mdi-trending-down',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.expense_module,
      },
      {
        path: '/daai/cash-expense-balance',
        title: 'Cash Expense & Balance',
        icon: 'mdi mdi-scale-balance',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.cashNExpense_module,
      },
      {
        path: '/daai/reimbursements',
        title: 'Reimbursement',
        icon: 'mdi mdi-cash-multiple',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.reimbursements_module,
      },
      {
        path: '/daai/challan',
        title: 'TDS Challan',
        icon: 'mdi mdi-receipt-text',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.challan_module,
      },
      {
        path: '/daai/suppliers',
        title: 'Vendors/Suppliers',
        icon: 'mdi mdi-account-multiple-plus',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.vendors_module,
      },
    ],
    module_name: module_names.static_module,
  },
  {
    path: '',
    title: 'Users',
    icon: 'mdi mdi-account-check',
    class: 'has-arrow',
    extralink: false,
    submenu: [
      {
        path: '/daai/authorities',
        title: 'Roles',
        icon: 'mdi mdi-account-settings',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.roles_module,
      },
      {
        path: '/daai/users',
        title: 'Users',
        icon: 'mdi mdi-account-multiple',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.users_module,
      },
    ],
    module_name: module_names.static_module,
  },
  {
    path: '',
    title: 'Statements',
    icon: 'mdi mdi-equal-box',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/daai/reports',
        title: 'Generate Statements',
        icon: 'mdi mdi-equal-box',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.reports_module,
      },
    ],
    module_name: module_names.reports_module,
  },
  {
    path: '',
    title: 'Settings',
    icon: 'mdi mdi-settings',
    class: 'has-arrow',
    extralink: false,
    submenu: [
      {
        path: '/daai/settings',
        title: 'Primary Settings',
        icon: 'mdi mdi-cog',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.settings_module,
      },
      {
        path: '/daai/general-settings',
        title: 'General Settings',
        icon: 'mdi mdi-cogs',
        class: '',
        extralink: false,
        submenu: [],
        module_name: module_names.dropdownsettings_module,
      },
    ],
    module_name: module_names.static_module,
  },
];
